export enum ApiStatusCodes {
    NOT_FOUND = 404,
    OK = 200,
    CONFLICT = 409,
    BAD_REQUEST = 400,
    DJ_IDP_CLIENT_ERROR = 570
}
